import { useMeeting, useParticipant, usePubSub } from "@videosdk.live/react-sdk";
import React, {
  useMemo,
  useState,
  useRef,
  useEffect,
  useCallback,
} from "react";
import MicOffIcon from "../../icons/ParticipantTabPanel/MicOffIcon";
import MicOnIcon from "../../icons/ParticipantTabPanel/MicOnIcon";
import RaiseHand from "../../icons/ParticipantTabPanel/RaiseHand";
import VideoCamOffIcon from "../../icons/ParticipantTabPanel/VideoCamOffIcon";
import VideoCamOnIcon from "../../icons/ParticipantTabPanel/VideoCamOnIcon";
import { useMeetingAppContext } from "../../MeetingAppContextDef";
import { nameTructed } from "../../utils/helper";
import { useSiteContext } from "../../context/SiteContext";
import useIsMobile from "../../hooks/useIsMobile";
import useWindowSize from "../../hooks/useWindowSize";
import { HostPermissionConfirmModal } from "../modals/PermissionRequestModal";


function ParticipantListItem({
  participantId,
  raisedHand,
  canUnmute,
  onToggleUnmutePermission,
  isMobileLandscape,
  onRequestMicPermission,
  onRequestVideoPermission,
  participantRole,
}) {
  const {
    micOn,
    webcamOn,
    displayName,
    isLocal,
    remove,
    mode,
    disableMic,
    disableWebcam,
    pin,
    pinState,
    unpin,
    metaData,
  } = useParticipant(participantId);
  const {
    meetingRole,
    selectedLayout,
    localPinnedParticipant,
    setLocalPinnedParticipant,
  } = useSiteContext();
  const { publish } = usePubSub("MUTE_MIC");
  const canModerate = ["moderator", "co-host"].includes(meetingRole);
  console.log(meetingRole, "meetingRole");

  const isHost = ["moderator", "co-host", "presenter"].includes(
    participantRole || metaData?.meetingRole
  );

  const avatarColor = isHost ? "#8344CA" : "#00C852";

  const getRoleLabel = () => {
    const role = participantRole || metaData?.meetingRole;
    if (role === "moderator") return "(Host)";
    if (role === "co-host") return "(Co-Host)";
    if (role === "presenter") return "(Presenter)";
    return "";
  };

  return (
    <div
      className={`bg-gray-700 rounded-lg mb-0 ${isMobileLandscape ? "mt-1 m-1 p-1" : "mt-2 m-2 p-2"
        }`}
    >
      <div className="flex flex-1 items-center justify-center relative">
        <div
          style={{
            color: "#ffffff",
            backgroundColor: avatarColor,
          }}
          className={`mt-0 rounded-full overflow-hidden flex relative items-center justify-center ${isMobileLandscape ? "h-7 w-7 text-sm" : "h-10 w-10 text-lg"
            }`}
        >
          {displayName?.charAt(0).toUpperCase()}
        </div>
        <div
          className={`mr-1 flex flex-1 ${isMobileLandscape ? "ml-1.5" : "ml-2"
            }`}
        >
          <p
            className={`text-white overflow-hidden whitespace-pre-wrap overflow-ellipsis ${isMobileLandscape ? "text-xs" : "text-base"
              }`}
          >
            {isLocal
              ? "You"
              : nameTructed(displayName, isMobileLandscape ? 12 : 15)}
            {getRoleLabel() && (
              <span className="text-gray-300"> {getRoleLabel()}</span>
            )}
          </p>
        </div>
        {raisedHand && (
          <div
            className={`flex items-center justify-center pointer-events-none ${isMobileLandscape ? "m-0.5 p-0.5" : "m-1 p-1"
              }`}
            title="Raised hand"
          >
            <RaiseHand
              fillcolor={"#fff"}
              width={isMobileLandscape ? 14 : 18}
              height={isMobileLandscape ? 14 : 18}
            />
          </div>
        )}
        {["moderator", "co-host"].includes(meetingRole) && (
          <div
            className={`cursor-pointer ${isMobileLandscape ? "m-0.5 p-0.5" : "m-1 p-1"
              }`}
            title={pinState.cam ? "Unpin participant" : "Pin participant"}
            onClick={() => {
              console.log("pinState", pinState);
              if (["moderator", "co-host"].includes(meetingRole)) {
                if (pinState.cam) {
                  unpin();
                } else {
                  pin();
                }
              }
            }}
          >
            {!pinState.cam && (
              <svg
                width={isMobileLandscape ? "16" : "20"}
                height={isMobileLandscape ? "16" : "20"}
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
              >
                <path
                  fill="none"
                  stroke="#fff"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M15.295 19.562L16 22m1-6l3.758 2.098M19 12.5l3.026-.598M7.61 6.3a3 3 0 0 0-3.92 1.3l-1.38 2.79a3 3 0 0 0 1.3 3.91l6.89 3.597a1 1 0 0 0 1.342-.447l3.106-6.211a1 1 0 0 0-.447-1.341zM8 9V2"
                />
              </svg>
            )}
            {pinState.cam && (
              <svg
                width={isMobileLandscape ? "16" : "20"}
                height={isMobileLandscape ? "16" : "20"}
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
              >
                <path
                  fill="none"
                  stroke="#a259ec"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M15.295 19.562L16 22m1-6l3.758 2.098M19 12.5l3.026-.598M7.61 6.3a3 3 0 0 0-3.92 1.3l-1.38 2.79a3 3 0 0 0 1.3 3.91l6.89 3.597a1 1 0 0 0 1.342-.447l3.106-6.211a1 1 0 0 0-.447-1.341zM8 9V2"
                />
              </svg>
            )}
          </div>
        )}
        {selectedLayout === "gallery" && !isLocal && (
          <div
            className={`cursor-pointer ${isMobileLandscape ? "m-0.5 p-0.5" : "m-1 p-1"
              }`}
            title={
              localPinnedParticipant.includes(participantId)
                ? "Unpin from your view"
                : "Pin to your view"
            }
            onClick={() => {
              console.log("pinState", pinState);
              if (localPinnedParticipant.includes(participantId)) {
                setLocalPinnedParticipant(
                  localPinnedParticipant.filter((p) => p !== participantId)
                );
              } else {
                setLocalPinnedParticipant([
                  ...localPinnedParticipant,
                  participantId,
                ]);
              }
            }}
          >
            {!localPinnedParticipant.includes(participantId) && (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 384 512"
                width={isMobileLandscape ? "16" : "20"}
                height={isMobileLandscape ? "16" : "20"}
                fill="none"
                stroke="#fff"
                strokeWidth="32"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M368 384c0-70.7-57.3-128-128-128V192h32c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16v128c0 8.8 7.2 16 16 16h32v64C73.3 256 16 313.3 16 384c0 8.8 7.2 16 16 16h144v96c0 8.8 7.2 16 16 16s16-7.2 16-16v-96h144c8.8 0 16-7.2 16-16z" />
              </svg>
            )}
            {localPinnedParticipant.includes(participantId) && (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 384 512"
                width={isMobileLandscape ? "16" : "20"}
                height={isMobileLandscape ? "16" : "20"}
                fill="none"
                stroke="#a259ec"
                strokeWidth="32"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M368 384c0-70.7-57.3-128-128-128V192h32c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16v128c0 8.8 7.2 16 16 16h32v64C73.3 256 16 313.3 16 384c0 8.8 7.2 16 16 16h144v96c0 8.8 7.2 16 16 16s16-7.2 16-16v-96h144c8.8 0 16-7.2 16-16z" />
              </svg>
            )}
          </div>
        )}
        {
          <div
            onClick={(e) => {
              e.stopPropagation();
              console.log(
                "role from participant panel",
                meetingRole,
                "micOn:",
                micOn,
                "participantId:",
                participantId
              );
              if (["moderator", "co-host"].includes(meetingRole)) {
                if (micOn) {
                  console.log("disableMic called from participant panel");
                  disableMic();
                } else if (!isLocal) {
                  // If mic is off and user is not local, request permission
                  onRequestMicPermission(participantId, displayName);
                }
              }
            }}
            className={`${isMobileLandscape ? "m-0.5 p-0.5" : "m-1 p-1"} ${["moderator", "co-host"].includes(meetingRole) && !isLocal
              ? "cursor-pointer"
              : ""
              }`}
            title={
              micOn
                ? canModerate
                  ? "Mute mic"
                  : "Mic on"
                : canModerate && !isLocal
                  ? "Request to unmute"
                  : "Mic off"
            }
          >
            {micOn ? (
              <MicOnIcon
                width={isMobileLandscape ? 14 : 18}
                height={isMobileLandscape ? 14 : 18}
              />
            ) : (
              <MicOffIcon
                width={isMobileLandscape ? 14 : 18}
                height={isMobileLandscape ? 14 : 18}
              />
            )}
          </div>
        }
        {
          <div
            onClick={() => {
              if (["moderator", "co-host"].includes(meetingRole)) {
                if (webcamOn) {
                  disableWebcam();
                } else if (!isLocal) {
                  // If camera is off and user is not local, request permission
                  onRequestVideoPermission(participantId, displayName);
                }
              }
            }}
            className={`${isMobileLandscape ? "m-0.5 p-0.5" : "m-1 p-1"} ${["moderator", "co-host"].includes(meetingRole) && !isLocal
              ? "cursor-pointer"
              : ""
              }`}
            title={
              webcamOn
                ? canModerate
                  ? "Disable camera"
                  : "Camera on"
                : canModerate && !isLocal
                  ? "Request to enable camera"
                  : "Camera off"
            }
          >
            {webcamOn ? (
              <VideoCamOnIcon
                width={isMobileLandscape ? 14 : 18}
                height={isMobileLandscape ? 14 : 18}
              />
            ) : (
              <VideoCamOffIcon
                width={isMobileLandscape ? 14 : 18}
                height={isMobileLandscape ? 14 : 18}
              />
            )}
          </div>
        }

        {["moderator", "co-host"].includes(meetingRole) && !isLocal && (
          <>
            {/* Allow/Disable Unmute Control */}
            {/* <div
              className="m-1 p-1 cursor-pointer hover:opacity-80 transition-opacity"
              onClick={(e) => {
                e.stopPropagation();
                onToggleUnmutePermission(participantId);
              }}
              title={canUnmute ? "Disable unmute for participant" : "Allow participant to unmute"}
            >
              {canUnmute ? (
                <svg
                  width="18"
                  height="18"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#4ade80"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" />
                  <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
                  <line x1="12" y1="19" x2="12" y2="23" />
                  <line x1="8" y1="23" x2="16" y2="23" />
                </svg>
              ) : (
                <svg
                  width="18"
                  height="18"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#ef4444"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="1" y1="1" x2="23" y2="23" />
                  <path d="M9 9v3a3 3 0 0 0 5.12 2.12M15 9.34V4a3 3 0 0 0-5.94-.6" />
                  <path d="M17 16.95A7 7 0 0 1 5 12v-2m14 0v2a7 7 0 0 1-.11 1.23" />
                  <line x1="12" y1="19" x2="12" y2="23" />
                  <line x1="8" y1="23" x2="16" y2="23" />
                </svg>
              )}
            </div> */}
            {/* Remove Participant */}
            <div
              className={`cursor-pointer ${isMobileLandscape ? "m-0.5 p-0.5" : "m-1 p-1"
                }`}
              onClick={() => remove(participantId)}
              title="Remove participant"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={isMobileLandscape ? "14" : "16"}
                height={isMobileLandscape ? "14" : "16"}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="text-white"
              >
                <path d="M3 6h18"></path>
                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"></path>
                <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                <line x1="10" y1="11" x2="10" y2="17"></line>
                <line x1="14" y1="11" x2="14" y2="17"></line>
              </svg>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export function ParticipantPanel({ panelHeight }) {
  const {
    raisedHandsParticipants,
    participantApproveFunc,
    setParticipantApproveFunc,
    activeSpeakerId,
  } = useMeetingAppContext();
  const mMeeting = useMeeting();
  const participants = mMeeting.participants;
  const { localParticipant } = mMeeting;
  const { meetingRole, activeElement } = useSiteContext();
  const { publish } = usePubSub("MUTE_MIC");
  const { publish: publishParticipantUnmutePermission } = usePubSub(
    "PARTICIPANT_UNMUTE_PERMISSION"
  );
  const { publish: publishMicPermissionRequest } = usePubSub(
    "MIC_PERMISSION_REQUEST"
  );
  const { publish: publishVideoPermissionRequest } = usePubSub(
    "VIDEO_PERMISSION_REQUEST"
  );
  const { publish: publishUnmutePermission } = usePubSub(
    "PARTICIPANT_UNMUTE_PERMISSION"
  );

  const { publish: publishParticipantApproved } = usePubSub(
    "PARTICIPANT_APPROVED_USERS"
  );

  const { publish: publishShowElementSection } = usePubSub("SHOW_ELEMENT_SECTION");


  const [searchQuery, setSearchQuery] = useState("");
  const [showMutedOnly, setShowMutedOnly] = useState(false);
  const [participantUnmutePermissions, setParticipantUnmutePermissions] =
    useState(new Map()); // Track per-participant unmute permissions
  const speakerHistoryRef = useRef([]); // Track last 3 active speakers
  const previousActiveSpeakerRef = useRef(null); // Track previous active speaker

  // Permission request modal states
  const [showHostMicConfirm, setShowHostMicConfirm] = useState(false);
  const [showHostVideoConfirm, setShowHostVideoConfirm] = useState(false);
  const [pendingPermissionRequest, setPendingPermissionRequest] =
    useState(null);

  const isMobile = useIsMobile();
  const windowSize = useWindowSize();
  const isLandscapeOrientation =
    (windowSize?.width || 0) > 0 &&
    (windowSize?.height || 0) > 0 &&
    windowSize.width > windowSize.height;
  const isMobileLandscape = isMobile && isLandscapeOrientation;

  // Subscribe to unmute permission changes from other moderators
  usePubSub("PARTICIPANT_UNMUTE_PERMISSION", {
    onMessageReceived: (data) => {
      const messageData = typeof data.message === "string" ? JSON.parse(data.message) : data.message;
      if (!messageData) return;
      if (messageData?.participantId && typeof messageData?.canUnmute === "boolean") {
        setParticipantUnmutePermissions((prev) => {
          const newMap = new Map(prev);
          if (messageData.canUnmute) {
            // Remove from map means allowed (default)
            newMap.delete(messageData.participantId);
          } else {
            // Set to false means disabled
            newMap.set(messageData.participantId, false);
          }
          return newMap;
        });
      }
    },
  });

  // Handle requesting mic permission from host/co-host
  const handleRequestMicPermission = (participantId, participantName) => {
    setPendingPermissionRequest({
      participantId,
      participantName,
      type: "mic",
    });
    setShowHostMicConfirm(true);
  };

  // Handle requesting video permission from host/co-host
  const handleRequestVideoPermission = (participantId, participantName) => {
    setPendingPermissionRequest({
      participantId,
      participantName,
      type: "video",
    });
    setShowHostVideoConfirm(true);
  };

  // Confirm mic permission request
  const handleConfirmMicPermission = () => {
    if (pendingPermissionRequest) {
      // Send permission to unmute
      publishUnmutePermission(JSON.stringify(
        {
          participantId: pendingPermissionRequest.participantId,
          canUnmute: true,
        }),
        { persist: false }
      );

      // Send the modal notification
      publishMicPermissionRequest(
        JSON.stringify({
          targetParticipantId: pendingPermissionRequest.participantId,
          granted: true,
        }),
        { persist: false }
      );
      console.log(
        "Mic permission request sent to:",
        pendingPermissionRequest.participantId
      );
    }
    setShowHostMicConfirm(false);
    setPendingPermissionRequest(null);
  };

  // Confirm video permission request
  const handleConfirmVideoPermission = () => {
    if (pendingPermissionRequest) {
      publishVideoPermissionRequest(
        JSON.stringify({
          targetParticipantId: pendingPermissionRequest.participantId,
          granted: true,
        }),
        { persist: false }
      );
      console.log(
        "Video permission request sent to:",
        pendingPermissionRequest.participantId
      );
    }
    setShowHostVideoConfirm(false);
    setPendingPermissionRequest(null);
  };

  // Cancel permission request
  const handleCancelPermission = () => {
    setShowHostMicConfirm(false);
    setShowHostVideoConfirm(false);
    setPendingPermissionRequest(null);
  };

  // Initialize permissions: by default, all participants can unmute unless explicitly disabled
  // Only moderators can toggle this
  const handleToggleUnmutePermission = (participantId) => {
    const currentPermission =
      participantUnmutePermissions.get(participantId) !== false;
    const newPermission = !currentPermission;

    setParticipantUnmutePermissions((prev) => {
      const newMap = new Map(prev);
      if (newPermission) {
        newMap.delete(participantId); // Remove from map means allowed (default)
      } else {
        newMap.set(participantId, false); // Explicitly set to false means disabled
      }
      return newMap;
    });

    // Publish the permission change to other participants
    publishParticipantUnmutePermission(JSON.stringify({
      participantId,
      canUnmute: newPermission,
    })
    );
  };

  const sortedRaisedHandsParticipants = useMemo(() => {
    const participantIds = [...participants.keys()];

    const notRaised = participantIds.filter(
      (pID) =>
        raisedHandsParticipants.findIndex(
          ({ participantId: rPID }) => rPID === pID
        ) === -1
    );

    const raisedSorted = raisedHandsParticipants.sort((a, b) => {
      if (a.raisedHandOn > b.raisedHandOn) {
        return -1;
      }
      if (a.raisedHandOn < b.raisedHandOn) {
        return 1;
      }
      return 0;
    });

    const combined = [
      ...raisedSorted.map(({ participantId: p }) => ({
        raisedHand: true,
        participantId: p,
      })),
      ...notRaised.map((p) => ({ raisedHand: false, participantId: p })),
    ];

    return combined;
  }, [raisedHandsParticipants, participants]);

  // Helper function to get participant role
  const getParticipantRole = useCallback(
    (participantId) => {
      if (participantId === localParticipant?.id) {
        return localParticipant?.metaData?.meetingRole || meetingRole;
      }
      const participant = participants.get(participantId);
      return participant?.metaData?.meetingRole;
    },
    [participants, localParticipant, meetingRole]
  );

  const isHostRole = useCallback((role) => {
    return ["moderator", "co-host", "presenter"].includes(role);
  }, []);

  const part = useMemo(() => {
    let filtered = sortedRaisedHandsParticipants;

    // Filter by muted status if enabled
    if (showMutedOnly) {
      filtered = filtered.filter(({ participantId }) => {
        if (participantId === localParticipant?.id) {
          return !localParticipant?.micOn;
        }
        const participant = participants.get(participantId);
        return !participant?.micOn;
      });
    }

    // Filter by search query if provided
    if (searchQuery.trim()) {
      const query = searchQuery.trim().toLowerCase();
      filtered = filtered.filter(({ participantId }) => {
        const participant = participants.get(participantId);
        const displayName = participant?.displayName || "";
        return displayName.toLowerCase().includes(query);
      });
    }

    // Update speaker history synchronously before sorting
    if (activeSpeakerId) {
      const previousActive = previousActiveSpeakerRef.current;

      // If active speaker changed (and we had a previous one)
      if (previousActive && previousActive !== activeSpeakerId) {
        // Remove previous active speaker from history if it exists
        let currentHistory = speakerHistoryRef.current.filter(
          (id) => id !== previousActive && id !== activeSpeakerId
        );

        // Add previous speaker to front of history
        speakerHistoryRef.current = [previousActive, ...currentHistory].slice(
          0,
          3
        );
      }

      // Remove current active speaker from history (if it exists)
      speakerHistoryRef.current = speakerHistoryRef.current.filter(
        (id) => id !== activeSpeakerId
      );

      // Update previous active speaker ref
      previousActiveSpeakerRef.current = activeSpeakerId;
    } else if (!activeSpeakerId) {
      // Clear previous if no active speaker
      previousActiveSpeakerRef.current = null;
    }

    // Sort: 1) Active speaker, 2) Last 3 speakers, 3) Participants with video on, 4) Others
    const sortedList = [];
    const remaining = [...filtered];

    const getParticipantWebcamStatus = (participantId) => {
      if (participantId === localParticipant?.id) {
        return localParticipant?.webcamOn || false;
      }
      const participant = participants.get(participantId);
      return participant?.webcamOn || false;
    };

    // 1. Current active speaker (first)
    if (activeSpeakerId) {
      const activeIndex = remaining.findIndex(
        ({ participantId }) => participantId === activeSpeakerId
      );
      if (activeIndex !== -1) {
        sortedList.push(remaining[activeIndex]);
        remaining.splice(activeIndex, 1);
      }
    }

    // 2. Last 3 speakers (in order: last speaker 1, 2, 3)
    const history = speakerHistoryRef.current;
    for (let i = 0; i < Math.min(3, history.length); i++) {
      const lastSpeakerId = history[i];
      const historyIndex = remaining.findIndex(
        ({ participantId }) => participantId === lastSpeakerId
      );
      if (historyIndex !== -1) {
        sortedList.push(remaining[historyIndex]);
        remaining.splice(historyIndex, 1);
      }
    }

    // 3. Participants with video on
    const videoOnItems = remaining.filter(({ participantId }) =>
      getParticipantWebcamStatus(participantId)
    );
    sortedList.push(...videoOnItems);
    videoOnItems.forEach((item) => {
      const index = remaining.indexOf(item);
      if (index > -1) {
        remaining.splice(index, 1);
      }
    });

    // 4. Others (participants without video)
    sortedList.push(...remaining);

    return sortedList;
  }, [
    sortedRaisedHandsParticipants,
    participants,
    searchQuery,
    activeSpeakerId,
    localParticipant,
    showMutedOnly,
  ]);

  // Separate participants into hosts and regular participants
  const { hosts, regularParticipants } = useMemo(() => {
    const hostsList = [];
    const regularList = [];

    part.forEach(({ participantId, raisedHand }) => {
      const role = getParticipantRole(participantId);
      const participantData = {
        participantId,
        raisedHand,
        role,
      };

      if (isHostRole(role)) {
        hostsList.push(participantData);
      } else {
        regularList.push(participantData);
      }
    });

    return { hosts: hostsList, regularParticipants: regularList };
  }, [part, getParticipantRole, isHostRole]);

  const handleMuteAll = () => {
    // Get all participants
    const participantIds = [...participants.keys()];

    // Mute all participants except the local user
    participantIds.forEach((participantId) => {
      const participant = participants.get(participantId);
      // Only mute if participant has mic on and is not local
      console.log("participant", participant);
      if (
        participant?.micOn &&
        !["moderator", "co-host"].includes(
          participant?.metaData?.meetingRole
        ) &&
        !participant?.isLocal
      ) {
        // publish(
        //   {
        //     participantId: participantId,
        //   },
        //   {
        //     persist: false,
        //   }
        // );
        participant.disableMic();
      }
    });
  };

  return (
    <>
      {/* Host Confirmation Modals */}
      <HostPermissionConfirmModal
        open={showHostMicConfirm}
        onConfirm={handleConfirmMicPermission}
        onCancel={handleCancelPermission}
        participantName={pendingPermissionRequest?.participantName || ""}
        permissionType="mic"
      />
      <HostPermissionConfirmModal
        open={showHostVideoConfirm}
        onConfirm={handleConfirmVideoPermission}
        onCancel={handleCancelPermission}
        participantName={pendingPermissionRequest?.participantName || ""}
        permissionType="video"
      />

      <div
        className={`flex w-full flex-col bg-gray-750 overflow-y-auto `}
        style={{ height: panelHeight }}
      >
        {["moderator", "co-host"].includes(meetingRole) && (
          <div
            className={`flex items-center justify-between border-b border-gray-700 ${isMobileLandscape ? "p-1.5" : "p-3"
              }`}
          >
            <button
              onClick={handleMuteAll}
              className={`${isMobileLandscape ? "px-2 py-1 text-xs" : "px-3 py-1 text-sm"
                } bg-red-600 text-white rounded hover:bg-red-700 transition-colors`}
            >
              Mute All
            </button>
          </div>
        )}
        {participantApproveFunc.length > 0 && (
          <div
            className="flex flex-col"
            style={{
              height: participantApproveFunc.length > 4 ? "40vh" : "auto",
              overflowY: "auto",
            }}
          >
            {participantApproveFunc.map((item) => {
              return (
                <div
                  key={item.participantId}
                  className="flex items-start justify-between p-4 border-b border-gray-700"
                >
                  <div className="text-white">{item.name}</div>
                  <div className="flex gap-2">
                    <button
                      onClick={() => {
                        item.allow();
                        setParticipantApproveFunc(
                          participantApproveFunc.filter(
                            (pitem) =>
                              pitem.participantId !== item.participantId
                          )
                        );

                        publishParticipantApproved(JSON.stringify({
                          participantId: item.participantId
                        }));
                        console.log("activeElement", activeElement);
                        if (activeElement) {
                          setTimeout(() => {
                            publishShowElementSection(JSON.stringify(activeElement), {
                              persist: true,
                            }, activeElement);
                          }, 5000);
                        }
                      }}
                      className="px-3 py-1 text-sm bg-green-600 text-white rounded hover:bg-green-700"
                    >
                      Admit
                    </button>
                    <button
                      onClick={() => {
                        item.deny();
                        setTimeout(() => {
                          setParticipantApproveFunc(
                            participantApproveFunc.filter(
                              (pitem) =>
                                pitem.participantId !== item.participantId
                            )
                          );
                        }, 500);
                      }}
                      className="px-3 py-1 text-sm bg-red-600 text-white rounded hover:bg-red-700"
                    >
                      Deny
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {/* Search Input and Muted Filter */}
        <div
          className={`border-b border-gray-700 ${isMobileLandscape ? "p-1.5" : "p-3"
            } ${isMobileLandscape ? "space-y-1" : "space-y-2"}`}
        >
          {isMobileLandscape ? (
            // Landscape: Horizontal compact layout
            <div className="flex gap-1.5 items-center">
              <div className="relative flex-1">
                <input
                  type="text"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  placeholder="Search..."
                  className="w-full px-2 py-1 pl-7 text-xs bg-gray-800 border border-gray-600 rounded text-white placeholder-gray-400 focus:outline-none focus:ring-1 focus:ring-indigo-500"
                />
                <svg
                  className="absolute left-2 top-1/2 transform -translate-y-1/2 w-3.5 h-3.5 text-gray-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
                {searchQuery && (
                  <button
                    onClick={() => setSearchQuery("")}
                    className="absolute right-1.5 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-white"
                    title="Clear search"
                  >
                    <svg
                      className="w-3.5 h-3.5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                )}
              </div>
              {/* Muted Filter Toggle - Compact */}
              <button
                onClick={() => setShowMutedOnly(!showMutedOnly)}
                className={`px-2 py-1 text-xs rounded transition-colors flex items-center justify-center gap-1 flex-shrink-0 ${showMutedOnly
                  ? "bg-[#7700FF] text-white hover:bg-[#7700FF]"
                  : "bg-gray-700 text-gray-300 hover:bg-gray-600"
                  }`}
                title={showMutedOnly ? "Show All" : "Show Muted Only"}
              >
                <MicOffIcon width={14} height={14} />
                <span className="hidden sm:inline">
                  {showMutedOnly ? "All" : "Muted"}
                </span>
              </button>
            </div>
          ) : (
            // Portrait/Desktop: Vertical layout
            <>
              <div className="relative">
                <input
                  type="text"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  placeholder="Search participants..."
                  className="w-full px-4 py-2 pl-10 bg-gray-800 border border-gray-600 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                />
                <svg
                  className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
                {searchQuery && (
                  <button
                    onClick={() => setSearchQuery("")}
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-white"
                    title="Clear search"
                  >
                    <svg
                      className="w-5 h-5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                )}
              </div>
              {/* Muted Filter Toggle */}
              <button
                onClick={() => setShowMutedOnly(!showMutedOnly)}
                className={`w-full px-3 py-2 text-sm rounded-lg transition-colors flex items-center justify-center gap-2 ${showMutedOnly
                  ? "bg-[#7700FF] text-white hover:bg-[#7700FF]"
                  : "bg-gray-700 text-gray-300 hover:bg-gray-600"
                  }`}
              >
                <MicOffIcon />
                <span>{showMutedOnly ? "Show All" : "Show Muted Only"}</span>
              </button>
            </>
          )}
        </div>

        <div
          className="flex flex-col flex-1 overflow-y-auto"
          style={{ height: panelHeight - 100 }}
        >
          {/* HOSTS Section */}
          {hosts.length > 0 && (
            <div className="mt-2">
              <div
                className={`text-white font-bold px-3 py-2 uppercase ${isMobileLandscape ? "text-xs" : "text-sm"
                  }`}
              >
                HOSTS ({hosts.length})
              </div>
              {hosts.map(({ raisedHand, participantId: peerId, role }) => {
                if (!peerId) return null;
                const canUnmute =
                  participantUnmutePermissions.get(peerId) !== false;
                return (
                  <ParticipantListItem
                    key={peerId}
                    participantId={peerId}
                    raisedHand={raisedHand}
                    canUnmute={canUnmute}
                    onToggleUnmutePermission={handleToggleUnmutePermission}
                    isMobileLandscape={isMobileLandscape}
                    onRequestMicPermission={handleRequestMicPermission}
                    onRequestVideoPermission={handleRequestVideoPermission}
                    participantRole={role}
                  />
                );
              })}
            </div>
          )}

          {/* PARTICIPANTS Section */}
          {regularParticipants.length > 0 && (
            <div className={hosts.length > 0 ? "mt-4" : "mt-2"}>
              <div
                className={`text-white font-bold px-3 py-2 uppercase ${isMobileLandscape ? "text-xs" : "text-sm"
                  }`}
              >
                PARTICIPANTS ({regularParticipants.length})
              </div>
              {regularParticipants.map(
                ({ raisedHand, participantId: peerId, role }) => {
                  if (!peerId) return null;
                  const canUnmute =
                    participantUnmutePermissions.get(peerId) !== false;
                  return (
                    <ParticipantListItem
                      key={peerId}
                      participantId={peerId}
                      raisedHand={raisedHand}
                      canUnmute={canUnmute}
                      onToggleUnmutePermission={handleToggleUnmutePermission}
                      isMobileLandscape={isMobileLandscape}
                      onRequestMicPermission={handleRequestMicPermission}
                      onRequestVideoPermission={handleRequestVideoPermission}
                      participantRole={role}
                    />
                  );
                }
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
}
